module.exports = __webpack_public_path__ + "files/d663a5d3e4b08213cb00f5bfafecf160.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/icons/patch.png
 ** module id = 383
 ** module chunks = 0
 **/